/**
 * Où l'enfant est déjà inscrit, la semaine de la session qu'il attend.
 *
 * Une famille s'inscrit souvent en liste d'attente pour l'activité qu'elle
 * voulait, et inscrit l'enfant ailleurs la même semaine en attendant.
 * Avant d'appeler, l'équipe doit le savoir : soit l'enfant a déjà une place
 * cette semaine-là (il s'agit alors de le changer d'activité), soit il n'en a
 * aucune, et la place libérée lui est vraiment nécessaire.
 *
 * « La même semaine », c'est une session dont les dates recoupent celles de
 * la session attendue. Une inscription annulée ne compte pas ; une
 * annulation seulement demandée tient encore la place, et se dit.
 */
import { estActive as inscriptionActive } from '../inscriptions/statut';
import { seRecoupent } from '../inscriptions/semaines';

export interface InscriptionDeLEnfant {
  id: string;
  kid_id: string;
  activity_id: string;
  cancellation_status: string | null;
  start_date: string;
  end_date: string;
  stage: string;
  centre: string;
}

export type SituationDeLaSemaine =
  | { cle: 'deja-inscrit' }
  | { cle: 'ailleurs'; inscriptions: InscriptionDeLEnfant[] }
  | { cle: 'nulle-part' };

export function situationDeLaSemaine(
  session: { id: string; start_date: string; end_date: string },
  kidId: string,
  inscriptions: readonly InscriptionDeLEnfant[],
): SituationDeLaSemaine {
  const memeSemaine = inscriptions
    .filter((i) =>
      i.kid_id === kidId &&
      inscriptionActive(i.cancellation_status) &&
      seRecoupent(i, session))
    .sort((a, b) => a.start_date.localeCompare(b.start_date) || a.stage.localeCompare(b.stage, 'fr'));

  if (memeSemaine.some((i) => i.activity_id === session.id)) return { cle: 'deja-inscrit' };
  if (memeSemaine.length > 0) return { cle: 'ailleurs', inscriptions: memeSemaine };
  return { cle: 'nulle-part' };
}
